import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Professional SMS Marketing Services</h1>
          <p>MEES HOLDINGS INC connects businesses with compliant, reliable SMS marketing solutions through our partnerships with leading service providers.</p>
          <Link to="/contact" className="cta-button">Get Started Today</Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Why Choose MEES HOLDINGS INC?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <h3>100% Compliant</h3>
              <p>Full TCPA, CAN-SPAM, and carrier compliance. We partner with leading SMS providers and ensure all campaigns meet A2P registration requirements.</p>
            </div>
            <div className="feature-card">
              <h3>High Deliverability</h3>
              <p>Partnering with tier-1 SMS providers ensures your messages reach customers reliably with excellent delivery rates.</p>
            </div>
            <div className="feature-card">
              <h3>Expert Support</h3>
              <p>Dedicated account management and professional support to ensure your campaigns run smoothly and effectively.</p>
            </div>
            <div className="feature-card">
              <h3>Advanced Analytics</h3>
              <p>Comprehensive reporting and real-time analytics to track performance, optimize campaigns, and maximize ROI.</p>
            </div>
            <div className="feature-card">
              <h3>Secure & Private</h3>
              <p>Strong data protection practices and secure handling of customer information to protect your business and customer data.</p>
            </div>
            <div className="feature-card">
              <h3>Flexible Solutions</h3>
              <p>From small businesses to growing companies, we help connect you with SMS solutions that meet your messaging needs and budget.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section" style={{background: '#f8fafc'}}>
        <div className="container">
          <h2 className="section-title">Professional SMS Marketing Solutions</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-number">5+</span>
              <span className="stat-label">Years in Business</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">Reliable</span>
              <span className="stat-label">Message Delivery</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">Growing</span>
              <span className="stat-label">Client Base</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">Expert</span>
              <span className="stat-label">Support Team</span>
            </div>
          </div>
        </div>
      </section>

      {/* Compliance Badges */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Industry Compliance & Certifications</h2>
          <div className="compliance-badges">
            <div className="badge">
              <h4>TCPA Compliant</h4>
              <p>Full compliance with Telephone Consumer Protection Act</p>
            </div>
            <div className="badge">
              <h4>CAN-SPAM Act</h4>
              <p>Adherent to all CAN-SPAM requirements</p>
            </div>
            <div className="badge">
              <h4>A2P Ready</h4>
              <p>Preparing for Application-to-Person registration</p>
            </div>
            <div className="badge">
              <h4>Preparing A2P Registration</h4>
              <p>Ready for carrier approval process</p>
            </div>
          </div>

          {/* SMS Program Disclosure */}
          <div style={{maxWidth: '800px', margin: '3rem auto 0', background: '#f0f9ff', padding: '2rem', borderRadius: '10px', border: '2px solid #3b82f6'}}>
            <h3 style={{color: '#1e40af', marginBottom: '1rem', textAlign: 'center'}}>SMS Program Information</h3>
            <p style={{marginBottom: '1rem', textAlign: 'center'}}>
              By opting in to receive SMS messages, you agree to receive automated marketing and transactional text messages. 
              Message frequency varies. Message and data rates may apply.
            </p>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginTop: '1.5rem'}}>
              <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>To Opt-Out</p>
                <p style={{fontSize: '0.9rem'}}>Reply STOP to any message</p>
              </div>
              <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>For Help</p>
                <p style={{fontSize: '0.9rem'}}>Reply HELP or visit <Link to="/support" style={{color: '#2563eb'}}>Support</Link></p>
              </div>
              <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem'}}>Full Terms</p>
                <p style={{fontSize: '0.9rem'}}><Link to="/sms-terms" style={{color: '#2563eb'}}>SMS Terms & Conditions</Link></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Verification Section */}
      <section className="section" style={{background: '#f8fafc'}}>
        <div className="container">
          <h2 className="section-title">Verified Business Entity</h2>
          <div style={{textAlign: 'center', maxWidth: '600px', margin: '0 auto'}}>
            <p style={{fontSize: '1.1rem', marginBottom: '2rem', color: '#4b5563'}}>
              MEES HOLDINGS INC is a verified business entity registered in New York State with complete 
              documentation available for A2P registration and carrier approval processes.
            </p>
            <Link to="/verification" style={{
              background: '#1e40af',
              color: 'white',
              padding: '12px 24px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              display: 'inline-block'
            }}>View Business Verification</Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section" style={{background: '#2563eb', color: 'white'}}>
        <div className="container" style={{textAlign: 'center'}}>
          <h2>Ready to Start Your SMS Marketing Campaign?</h2>
          <p style={{fontSize: '1.2rem', margin: '1rem 0 2rem'}}>
            Join thousands of businesses who trust MEES HOLDINGS INC for their SMS marketing needs.
          </p>
          <Link to="/contact" className="cta-button">Contact Us Today</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;